import { useContext } from "react";
import { ChimeMeetingContext } from "../providers";

/**
 * Hook that returns the chime meeting context value
 * 
 * @returns The chime meeting context
 */
const useChimeMeeting = () => {
  const chimeMeetingContext = useContext(ChimeMeetingContext);

  if (!chimeMeetingContext) {
    throw new Error(
      "useChimeMeeting must be used within an ChimeMeetingProvider",
    );
  }
  return chimeMeetingContext;
};

export default useChimeMeeting;
